import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { Column, ColumnKeys } from '../types';
import { WEB_COMPONENT_GRID_VIEW } from '../../../webcomponents.constants';
import { GridViewWebComponent } from '../../../grid/gridView';
import { ExclusionItemGridDataProvider } from '../dataProvider/ExclusionItemGridDataProvider';
import { ExclusionItemGridConfig } from './ExclusionItemGridConfig';

export class ExclusionItemGridView extends BaseWebComponentView {

  public dom: {
    $wrapper: HTMLElement;
    $gridView: GridViewWebComponent<Column, ColumnKeys>;
  }

  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$gridView = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW) as GridViewWebComponent<Column, ColumnKeys>;

    if (this.dom.$gridView.injectDependencies) {
      this.dom.$gridView.injectDependencies(this.dependencies);
      this.dom.$gridView.start().then().catch(console.error);
    }
  }

  buildView(data: any) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }

    this.buildGridView(data);
  }

  private buildGridView(data: any) {
    this.dom.$gridView.propertiesSet = false;
    (new ExclusionItemGridConfig(new ExclusionItemGridDataProvider(this.dependencies), this.dom.$gridView)).setGridViewMetadata(this.dom.$gridView);
    this.dom.$gridView.propertiesSet = true;
  }

  public onExclusionItemDelete(ev) {
    const itemId = ev.target.getAttribute('data-internal-id');
    (this.dom.$gridView.dataProvider as ExclusionItemGridDataProvider).deleteItem(itemId);
    this.dom.$gridView.controller?.handleGridItemsLoad();
  }
}
